import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var regionSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
};
export default regionSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/regionSchema.ts
// module id = 424
// module chunks = 0